module.exports = __webpack_public_path__ + "img/icon-counter.2e6c8399.svg";